import React from "react";

export default function RemainderPopup({ task, onClose }) {

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
        <div className="bg-white p-8 rounded shadow-lg">
          <h2 className="text-2xl mb-4">Task Reminder</h2>
          <p className="mb-4">Task: {task.notes}</p>
          <button
            className="bg-gray-300 text-white py-2 px-4 rounded"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
}
